/**
 * Canonical OrivonLogo heights — align public nav, footers, demo, and in-app sidebars.
 * LandingNav compact breakpoint: (max-width: 900px) — see Nav.js.
 */
export const LOGO_HEIGHT_NAV_COMPACT = 34;
export const LOGO_HEIGHT_NAV_WIDE = 38;

/** Fixed-width sidebars (AppNav, Layout, DashboardNav, ChapterDemoNav). */
export const LOGO_HEIGHT_SIDEBAR = 34;
